import React from "react";
import { useTranslation } from "react-i18next";
import "../i18n"; // important to import
const RejectKid = () => {
  const { t } = useTranslation("RejectKid");
  return (
    <section>
      <div className="p-4 p-md-5">
        <header className="top-title-header">
          <h1>{t("unicorso")} </h1>
          <p>{t("lifelonglearningforkids")}</p>
        </header>
        <main className="main-body">
          <h2>{t("question1")}</h2>
          <p>{t("answer1")}</p>
          <ul className="ps-0">
            <li>
              <strong>{t("question2")} </strong>
              <p>{t("answer2")}</p>
            </li>
            <li>
              <strong>{t("question3")} </strong>
              <p>{t("answer3")}</p>
            </li>
            <li>
              <strong>{t("question4")} </strong>
              <p>{t("answer4")}</p>
            </li>
            <li>
              <strong>{t("question5")}</strong>
              <p>
                <p>
                  {t("answerhalf1")} <a href="#pricing">{t("answerhalf2")}</a>.
                </p>
              </p>
            </li>
            <li>
              <strong>{t("question6")}</strong>
              <p> {t("answer6")} </p>
            </li>
            <li>
              <strong> {t("question7")}</strong>
              <p> {t("answer7")}</p>
            </li>
            <li>
              <strong> {t("question8")}</strong>
              <p> {t("answer8")}</p>
            </li>
          </ul>
        </main>
        <footer>
          <p>{t("rightsdes")} </p>
        </footer>
      </div>
    </section>
  );
};

export default RejectKid;
